import { ReactComponent as AllRequest } from '../../../resource/statistics/allRequests.svg';
import { ReactComponent as TimeRequest } from '../../../resource/statistics/timeRequests.svg';
import { ReactComponent as SuccessRequest } from '../../../resource/statistics/successRequest.svg';
import { ReactComponent as StopMinusOctagon } from '../../../resource/statistics/stopMinusOctagon.svg';

export const reportIcons = {
  'Поступило заявок': AllRequest,
  Выполнено: SuccessRequest,
  Аннулировано: StopMinusOctagon,
  'Сроки выполнения': TimeRequest,
};
